import React from "react";
import Users from "../../resources/Users.png";
import Locations from "../../resources/Locations.png";
import Websites from "../../resources/Websites.png";
import "./HomeSectionTwo.css";

function HomeSectionTwo() {
  return (
    <div className="homeSectionTwo">
      <div className="homeSectionTwo__box">
        <div className="homeSectionTwo__box--one">
          <div className="homeSectionTwo__box--one--img">
            <img src={Users} />
          </div>
          <div className="homeSectionTwo__box--one--info">
            <div className="homeSectionTwo__box--one--title">
              <p>350+</p>
            </div>
            <div className="homeSectionTwo__box--one--subTitle">
              <p>Users</p>
            </div>
          </div>
        </div>

        <div className="homeSectionTwo__box--two">
          <div className="homeSectionTwo__box--two--img">
            <img src={Locations} />
          </div>
          <div className="homeSectionTwo__box--two--info">
            <div className="homeSectionTwo__box--two--title">
              <p>900+</p>
            </div>
            <div className="homeSectionTwo__box--two--subTitle">
              <p>Happy Clients</p>
            </div>
          </div>
        </div>

        <div className="homeSectionTwo__box--three">
          <div className="homeSectionTwo__box--three--img">
            <img src={Websites} />
          </div>
          <div className="homeSectionTwo__box--three--info">
            <div className="homeSectionTwo__box--three--title">
              <p>1900+</p>
            </div>
            <div className="homeSectionTwo__box--three--subTitle">
              <p>Websites</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeSectionTwo;
